<template>
  <div 
    class="pie"
  >
   <canvas :id="'myChart' + id"></canvas>
  </div>
</template>
<script>
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  name: 'GraphicCustomPie',
  props: {
    data: {
      type: [Array, Object],
      required: true
    },
    id: {
      type: String,
      default: ''
    }
  },
  mounted() {
    const ctx = document.getElementById("myChart" + this.id);
   Chart.register(ChartDataLabels)
   const myChart = new Chart(ctx, {
   type: 'doughnut',
   data: {
      datasets: [
          {
            data: this.values.values,
            backgroundColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(65,211,82)',
              'rgb(243,101,35)',
              'rgb(114,14,158)',
              'rgb(179,205,216)',
              'rgb(176,176,176)',
              'rgb(224,123,106)',
              'rgb(51,51,51)',
              'rgb(59,92,179)',
              'rgb(210,13,123)',
              'rgb(140,109,97)'
            ],
          },
        ],
        labels: this.values.labels,
      },
      options: {
        plugins: {
          datalabels: {
            font: {
              size: 16,
              weight: 600
            },
            formatter: (value) => {
              return value;
            },
          },
        },
      },
    })
  },
  computed: {
    values () {
      let values = []
      let labels = []

      this.data.forEach(item => {
        
        if (item.percentage != null) {
          item.value = item.percentage
        }


        if (item.value != 0) {
          values.push(item.value)
          labels.push(item.transName)
        }
      });

      return {
        values: values,
        labels: labels
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .pie {
    min-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }
</style>